// Validation utility functions

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePassword = (password) => {
  return password.length >= 6;
};

export const validatePhoneNumber = (phone) => {
  const phoneRegex = /^[0-9]{10}$/;
  return phoneRegex.test(phone.replace(/\D/g, ""));
};

export const validateGSTNumber = (gst) => {
  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  return gstRegex.test(gst.toUpperCase());
};

export const validatePincode = (pincode) => {
  return /^[0-9]{6}$/.test(pincode);
};

export const validateLoginForm = (email, password, role) => {
  const errors = {};

  if (!email || email.trim() === "") {
    errors.email = "Email or User ID is required";
  } else if (!validateEmail(email) && !email.match(/^[0-9]+$/)) {
    errors.email = "Please enter a valid email or user ID";
  }

  if (!password || password.trim() === "") {
    errors.password = "Password is required";
  } else if (!validatePassword(password)) {
    errors.password = "Password must be at least 6 characters";
  }

  return { isValid: Object.keys(errors).length === 0, errors };
};

export const validateRegistrationStep1 = (email, phone, password, confirmPassword, otpVerified) => {
  const errors = {};

  if (!otpVerified) {
    errors.otp = "Please verify your email OTP first";
  }

  if (!email || email.trim() === "") {
    errors.email = "Email is required";
  } else if (!validateEmail(email)) {
    errors.email = "Please enter a valid email";
  }

  if (!phone || phone.trim() === "") {
    errors.phone_number = "Phone number is required";
  } else if (!validatePhoneNumber(phone)) {
    errors.phone_number = "Please enter a valid 10-digit phone number";
  }

  if (!password || password.trim() === "") {
    errors.password = "Password is required";
  } else if (!validatePassword(password)) {
    errors.password = "Password must be at least 6 characters";
  }

  if (!confirmPassword || confirmPassword.trim() === "") {
    errors.confirmPassword = "Confirm password is required";
  } else if (password !== confirmPassword) {
    errors.confirmPassword = "Passwords do not match";
  }

  return { isValid: Object.keys(errors).length === 0, errors };
};

export const validateRegistrationStep2 = (businessName, ownerName, gstNumber) => {
  const errors = {};

  if (!businessName || businessName.trim() === "") {
    errors.business_name = "Business name is required";
  }

  if (!ownerName || ownerName.trim() === "") {
    errors.owner_name = "Owner name is required";
  }

  if (!gstNumber || gstNumber.trim() === "") {
    errors.gst_number = "GST number is required";
  } else if (!validateGSTNumber(gstNumber)) {
    errors.gst_number = "Please enter a valid GST number";
  }

  return { isValid: Object.keys(errors).length === 0, errors };
};

export const validateRegistrationStep3 = (address, city, pincode, state) => {
  const errors = {};

  if (!address || address.trim() === "") {
    errors.address = "Address is required";
  }

  if (!city || city.trim() === "") {
    errors.city = "City is required";
  }

  if (!state || state.trim() === "") {
    errors.state = "State is required";
  }

  if (!pincode || pincode.trim() === "") {
    errors.pincode = "Pincode is required";
  } else if (!validatePincode(pincode)) {
    errors.pincode = "Please enter a valid 6-digit pincode";
  }

  return { isValid: Object.keys(errors).length === 0, errors };
};
